import { AnyAction } from "redux";

import { GetAppParameter, UpdateAppParameter, ResetSiteConfiguration } from '../actions/actionTypes';
import { updateObject } from '../../services/utilService';
import update from 'react-addons-update';

const initialState = {    
    appParameters : []
};

const getAppParameter = (state: any, action: any) => {
    return updateObject(state, { appParameters: action.payload });
}

const updateAppParameter = (state: any, action: any) => {
    const paramIndex = state.appParameters.findIndex((param: any) => param.id === action.payload.appParameter.id);
    return update(state, {
        appParameters: {
            [paramIndex] :{
                hours:{$set:+action.payload.hours }
            }
        }
    })
}

const resetToInitialState = (state: any) => {
    return updateObject(state, initialState);
}

const SiteConfigReducer = (state = initialState, action: AnyAction) => {
    switch(action.type) {
        case GetAppParameter: return getAppParameter(state, action);
        case UpdateAppParameter: return updateAppParameter(state, action);
        case ResetSiteConfiguration: return resetToInitialState(state);
        default: return state;
    } 
}

export default SiteConfigReducer;